import React, { useContext } from 'react';
import { path } from 'ramda';
import { getAttributeInfo } from '../../../../../../Model/avenyModelUtils';
import { attributeDefToDataPath } from '../../../../../../Utils/dataUtils';
import { StatistikrapporteringQuery_node_TEDBOAktivitet } from '../Queries/_QueryTypes/StatistikrapporteringQuery';
import AttributeValue from '../../../../../../Components/Attributes/AttributeValue/AttributeValue';
import clientAvenyModel from '../../../../../../Model/clientAvenyModel';
import { ModelContext } from '../../../../../../Model/ModelContext/ModelContext';
import { IClientBusinessModel } from '../../../../../../Types/ClientModelTypes';
import EDTooltip from '../../../../../../BaseComponents/Tooltip/EDTooltip';

interface IProps {
  statNodeData:
    | StatistikrapporteringQuery_node_TEDBOAktivitet
    | null
    | undefined;
  attributeName: string;
  label?: string;
  tooltip?: string;
}
const statistikModel: IClientBusinessModel =
  clientAvenyModel.BO.BusinessModels.BOAktivitet;

export const StatAttributeValue: React.FC<
  React.PropsWithChildren<IProps>
> = props => {
  const { avenyCollectionMap } = useContext(ModelContext);
  const attrInfo = getAttributeInfo(
    statistikModel,
    props.attributeName,
    avenyCollectionMap
  );
  const dataPath = attributeDefToDataPath(props.attributeName);
  const value =
    props.statNodeData && (path(dataPath, props.statNodeData) as string);
  return props.tooltip ? (
    <EDTooltip title={props.tooltip}>
      <AttributeValue
        collection={statistikModel}
        attribute={attrInfo.attribute}
        value={value}
        label={props.label}
        size="large"
      />
    </EDTooltip>
  ) : (
    <AttributeValue
      collection={statistikModel}
      attribute={attrInfo.attribute}
      value={value}
      label={props.label}
      size="large"
    />
  );
};
